import request from "@/service";

/* 查询角色列表 */
export function roleList(params) {
  return request({
    url: `/user/sys/role/page?page=${params.page}&limit=${
      params.limit
    }&roleName=${params.roleName !== undefined ? params.roleName : ""}`,
    method: "get"
  });
}

/* 新增角色 */
export function roleSave(data) {
  return request({
    url: `/user/sys/role/save`,
    method: "post",
    data
  });
}

/* 更新角色信息 */
export function roleUpdate(data) {
  return request({
    url: `/user/sys/role/update`,
    method: "put",
    data
  });
}

/* 批量删除角色 */
export function roleDelete(data) {
  return request({
    url: `/user/sys/role/delete`,
    method: "delete",
    data
  });
}

// 获取部门角色列表
export function getRolesByDept(deptId) {
  return request({
    url: `/user/sys/role/list/${deptId}`,
    method: "get"
  });
}

// 获取角色授权菜单
export function getRoleMenu(uuid) {
  return request({
    url: `/user/sys/role/menu/${uuid}`,
    method: "get"
  });
}

// 获取角色列表
export function getRoleList() {
  return request({
    url: `/user/sys/role/roleList`,
    method: "get"
  });
}
